import { FC } from "react";
import { ImagePlaceholder } from "../../assets";
import styles from "./ProductPhotoCell.module.css";

interface Props {
  name: string;
  image?: string;
  onPreview?: (imageId: string) => void;
}

export const ProductPhotoCell: FC<Props> = ({ name, image, onPreview }) => {
  const handleClick = () => {
    if (!onPreview || !image) return;
    onPreview(image);
  };

  return (
    <div className={styles.wrapper}>
      <span className={styles.container} onClick={handleClick}>
        {image ? <img src={image} alt={name} /> : <ImagePlaceholder />}
      </span>
      {name}
    </div>
  );
};
